var _defs, _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJogptPulsatingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 209.2 199.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #14a2dc;\n      }\n\n      .st1 {\n        fill: #338935;\n      }\n\n      .st2 {\n        fill: #d92d27;\n      }\n\n      .st3 {\n        fill: #00a3e0;\n      }\n\n      .st4 {\n        fill: #143156;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 150.5,
    cy: 51.7,
    r: 6.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 169.9,
    cy: 51.7,
    r: 6.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 150.5,
    cy: 51.7,
    r: 6.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 131.2,
    cy: 51.7,
    r: 6.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.1,88.1h-48.3c-2.1,0-3.8,1.7-3.8,3.8s1.7,3.8,3.8,3.8h57.2s-4.1-2.7-8.9-7.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.6,70.7h-36.8c-2.1,0-3.8,1.7-3.8,3.8s1.7,3.8,3.8,3.8h40.6c-1.4-2.3-2.7-4.8-3.7-7.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M178.8,96.2c-.6-4-1.5-8-2.7-11.8l-9.7,3.1c1.1,3.3,1.9,6.8,2.4,10.3.5,3.4.8,6.9.8,10.4,0,37.9-30.8,68.6-68.6,68.6s-28-4.3-39.6-12.6c-1.2-.8-2.7-.6-4.5-.6-3.4,0-8.3,1.4-16,3.7-2.5.7-5.9,1.7-8.8,2.4,1.2-2.4,2.7-5.1,3.8-7.2,1.8-3.3,3.6-6.7,4.9-9.6,1.5-3.4,3-7.2,1-10.4-.2-.3-.5-.7-.7-1-5.7-10.2-8.7-21.7-8.7-33.4,0-37.9,30.8-68.6,68.6-68.6s8.2.4,12.3,1.1l1.8-10c-4.6-.8-9.3-1.2-14.1-1.2-43.5,0-78.8,35.4-78.8,78.8s3.3,26.3,9.6,37.8h0c.1.2.3.5.4.7,0,0,0,0,0,0-.8,2.4-3.6,7.6-5.4,10.9-1.9,3.4-3.8,7-5.1,9.9-1.2,2.7-3.4,7.6-.3,11.1,2.6,3,6.9,2.4,11,1.5,3.3-.7,7.3-1.9,11.3-3,3.7-1.1,10.1-3.4,12.9-3.8h0c13.1,9,28.3,13.7,44.4,13.7,43.5,0,78.8-35.4,78.8-78.8s-.3-8-.9-11.9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M150,95.6c-11.7,0-22.7-4.6-31-12.9-8.3-8.3-12.9-19.3-12.9-31s4.6-22.7,12.9-31c8.3-8.3,19.3-12.9,31-12.9s22.7,4.6,31,12.9c8.3,8.3,12.9,19.3,12.9,31s-.8,12.7-4.4,19.4c.6,1.3,1.6,3.1,2.3,4.4,1,1.8,2.1,3.7,2.8,5.4.7,1.6,2.5,5.4-.1,8.4-2.4,2.8-6.2,2-8.1,1.6-1.8-.4-4-1-6.1-1.6-1.7-.5-3.9-1.1-5.4-1.4-7,5.4-14.3,7.7-24.9,7.7ZM150,18c-18.6,0-33.7,15.1-33.7,33.7s15.1,33.7,33.7,33.7,14.3-1.7,19.8-6.4c2.2-1.9,5-1.5,7.5-1,1.5.3,3.2.8,5,1.3-.8-1.4-1.5-2.8-2.1-4-.7-1.6-2.2-4.8-.4-7.7,2.9-4.7,3.9-8.9,3.9-15.8,0-18.6-15.1-33.7-33.7-33.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJogptPulsatingIcon);
export default __webpack_public_path__ + "static/media/jogpt_pulsating_icon.c2ecce2286e4393a564d1989bba727f8.svg";
export { ForwardRef as ReactComponent };